import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";
import { Observable, of } from "rxjs";

export const backofficeGuard = (): Observable<boolean> => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (auth.isBackOffice()) return of(true);

  if (auth.isDealer()) {
    router.navigateByUrl('/dealer-system/dashboard');
  }
  
  return of(false);
};
